import { formatCountOfTotal, formatRequestCount } from './crawlerEvidenceFigures';

export type UrlImpact = {
  readonly figure: string;
  readonly share: string | null;
};

const URL_UNIT = 'URLs';

const shareOf = (affected: number, crawled: number): string => {
  const percent = Math.round((affected / crawled) * 100);

  if (affected > 0 && percent === 0) return '<1%';
  if (affected < crawled && percent === 100) return '>99%';

  return `${percent}%`;
};

export function urlImpactOf(affected: number, crawled: number): UrlImpact {
  if (crawled === 0 || affected > crawled) return { figure: formatRequestCount(affected), share: null };

  return { figure: formatCountOfTotal(affected, crawled), share: shareOf(affected, crawled) };
}

export function urlImpactLine({ figure, share }: UrlImpact): string {
  return share === null ? `${figure} ${URL_UNIT}` : `${figure} ${URL_UNIT} (${share})`;
}

export function urlImpactValue({ figure, share }: UrlImpact): string {
  return share === null ? `${figure} ${URL_UNIT}` : figure;
}
